var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTherapyIconSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "url(#paint0_linear_209_67292)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_67292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8221 16.9237C36.3043 16.8907 35.9111 17.3031 35.8222 17.8142C35.6005 19.0885 35.1156 21.4085 35.1156 21.4085L35.1155 21.4087C35.0779 21.2691 34.9978 21.1331 34.8616 21.006C34.4443 20.6168 33.6589 20.9859 32.8709 21.5638C31.4936 22.4678 31.1313 22.9027 30.2867 23.1111C29.8426 23.2206 29.1195 23.4714 28.2795 24.0407C26.8981 24.9769 26.312 26.9645 26.5161 28.4146C26.6338 29.2513 26.5926 29.9015 26.6007 30.4824H31.1199L31.1193 29.5037C31.1192 29.3367 31.216 29.1844 31.3682 29.1153C32.2337 28.7224 34.6101 27.3411 35.9836 25.8717C37.0739 24.7051 37.6507 20.4025 37.7341 18.0423C37.7547 17.4555 37.4063 16.961 36.8221 16.9237Z",
    fill: "url(#paint1_linear_209_67292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9169 21.0849C35.8891 20.9709 35.7568 20.5022 35.3886 20.0586C35.2369 20.8122 35.1123 21.4083 35.1123 21.4083L35.1122 21.4085C35.131 21.7478 35.0085 22.834 33.1728 24.0053C31.0658 25.3496 31.0599 25.3768 31.0144 25.5873C30.924 26.0053 31.441 26.2916 31.7452 25.981C31.8071 25.9327 32.1316 25.6943 33.6374 24.7335C36.3375 23.0108 35.9664 21.2718 35.9169 21.0849Z",
    fill: "#EEE2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1985 29.2508C29.5547 30.0919 27.517 29.5793 26.4766 28.0078C26.4821 28.1466 26.4939 28.2823 26.5123 28.4135C26.63 29.2503 26.5888 29.9004 26.5969 30.4813H31.1161C31.14 29.5574 31.058 29.4436 31.1985 29.2508Z",
    fill: "#F2E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0636 32.506H25.8711V30.7041C25.8711 30.518 26.0219 30.3672 26.208 30.3672H31.7268C31.9128 30.3672 32.0636 30.518 32.0636 30.7041V32.506Z",
    fill: "#D4648A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4961 33.8915H24.6115V32.6764C24.6115 32.5509 24.4138 32.4492 24.1699 32.4492H16.9376C16.6937 32.4492 16.4961 32.5509 16.4961 32.6764V33.8915Z",
    fill: "#F16480",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 33.8915H33.1154V32.6764C33.1154 32.5509 32.9177 32.4492 32.6738 32.4492H25.4415C25.1976 32.4492 25 32.5509 25 32.6764V33.8915Z",
    fill: "#F16480",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7018 16.9237C13.2196 16.8907 13.6128 17.3031 13.7017 17.8142C13.9234 19.0885 14.4083 21.4085 14.4083 21.4085L14.4084 21.4087C14.446 21.2691 14.5261 21.1331 14.6623 21.006C15.0795 20.6168 15.865 20.9859 16.6529 21.5638C18.0303 22.4678 18.3926 22.9027 19.2371 23.1111C19.6813 23.2206 20.4044 23.4714 21.2444 24.0407C22.6258 24.9769 23.2119 26.9645 23.0078 28.4146C22.8908 29.2463 22.932 29.8849 22.9232 30.4824H18.404L18.4046 29.5037C18.4047 29.3367 18.3078 29.1844 18.1557 29.1153C17.2902 28.7224 14.9138 27.3411 13.5403 25.8717C12.4501 24.7052 11.8733 20.4027 11.7899 18.0425C11.7692 17.4555 12.1176 16.961 12.7018 16.9237Z",
    fill: "url(#paint2_linear_209_67292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6029 21.0849C13.6308 20.9709 13.7631 20.5022 14.1314 20.0586C14.2831 20.8122 14.4077 21.4083 14.4077 21.4083L14.4078 21.4085C14.389 21.7478 14.5114 22.834 16.3471 24.0053C18.4542 25.3496 18.46 25.3768 18.5056 25.5873C18.596 26.0053 18.0789 26.2916 17.7747 25.981C17.7129 25.9327 17.3883 25.6943 15.8825 24.7335C13.1824 23.0108 13.5536 21.2718 13.6029 21.0849Z",
    fill: "#EEE2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3203 29.2508C19.9641 30.0919 22.0019 29.5793 23.0422 28.0078C23.0367 28.1466 23.0249 28.2823 23.0065 28.4135C22.8895 29.2452 22.9307 29.8839 22.9218 30.4813H18.4027C18.3788 29.5574 18.4608 29.4436 18.3203 29.2508Z",
    fill: "#F2E9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.457 32.506H23.6496V30.7041C23.6496 30.518 23.4987 30.3672 23.3127 30.3672H17.7939C17.6078 30.3672 17.457 30.518 17.457 30.7041V32.506Z",
    fill: "#D4648A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0328 21.6408C24.9055 23.4463 20.8925 22.3709 19.087 19.2438C17.2815 16.1165 18.3568 12.1035 21.484 10.298C24.6112 8.49243 28.6242 9.56778 30.4298 12.695C32.2352 15.8222 31.16 19.8352 28.0328 21.6408Z",
    fill: "url(#paint3_linear_209_67292)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0669 9.385C28.5495 9.62793 27.7825 10.724 27.7825 11.9216V15.8912C27.7825 17.6352 26.5115 18.1867 25.6418 18.36C25.602 18.3679 25.5649 18.338 25.5649 18.2974V10.4044C25.5649 9.22004 26.6591 8.82491 26.8804 8.75034C26.9229 8.73603 26.9513 8.69647 26.9513 8.65169V8.62313C26.9513 8.55946 26.8997 8.50781 26.836 8.50781L22.8453 8.50781C22.7873 8.50781 22.7403 8.55481 22.7403 8.61281V8.65164C22.7403 8.69647 22.7688 8.73598 22.8112 8.75028C23.0326 8.82491 24.1268 9.2201 24.1268 10.4044V18.2973C24.1268 18.3379 24.0897 18.3679 24.0499 18.36C23.1802 18.1867 21.9092 17.6352 21.9092 15.8911V11.9216C21.9092 10.7239 21.142 9.62773 19.6244 9.38494C19.4707 9.36036 19.3859 9.55491 19.5062 9.65355C19.8936 9.97106 20.3498 10.564 20.3498 11.5962V15.8912C20.3498 15.8912 20.3962 18.4511 24.068 18.7692C24.1011 18.772 24.1267 18.7995 24.1267 18.8327L24.1267 23.1201C24.1267 23.2647 24.0095 23.382 23.8648 23.382C23.6683 23.382 23.4969 23.5335 23.491 23.7299C23.485 23.9332 23.6479 24.0998 23.8498 24.0998H25.8267C26.0232 24.0998 26.1946 23.9484 26.2005 23.7519C26.2066 23.5486 26.0436 23.382 25.8418 23.382C25.6888 23.382 25.5649 23.2581 25.5649 23.1052L25.5649 18.8328C25.5649 18.7996 25.5906 18.7721 25.6236 18.7692C29.2955 18.4511 29.3418 15.8913 29.3418 15.8913V11.5962C29.3418 10.564 29.7982 9.97106 30.1855 9.65355C30.3058 9.55486 30.2204 9.36041 30.0669 9.385Z",
    fill: "#D4648A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_209_67292",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 45.4327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114585,
    stopColor: "#F16480",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333339,
    stopColor: "#F16480",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776056,
    stopColor: "#F16480",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_209_67292",
    x1: 32.1057,
    y1: 16.9219,
    x2: 32.1057,
    y2: 30.4824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_209_67292",
    x1: 17.4182,
    y1: 16.9219,
    x2: 17.4182,
    y2: 30.4824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEE5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_209_67292",
    x1: 24.7584,
    y1: 9.42187,
    x2: 24.7584,
    y2: 22.5169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F490A4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_67292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.4423,
    height: 26.4423,
    fill: "white",
    transform: "translate(11.5391 8.50781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTherapyIconSetting);
export default __webpack_public_path__ + "static/media/therapy-icon-setting.432b0aa0c6d3f6a4a891a450d19997b8.svg";
export { ForwardRef as ReactComponent };